import type { CSSProperties } from 'react';

const TOOTH =
  'M50 22c-8-8-20-12-28-8-12 6-14 22-8 38 4 12 6 28 12 38 4 6 12 4 14-6 2-12 6-18 10-18 4 0 8 6 10 18 2 10 10 12 14 6 6-10 8-26 12-38 6-16 4-32-8-38-8-4-20 0-28 8z m-4 9h8v9h9v8h-9v9h-8v-9h-9v-8h9z';

/** The Dentlog mark, flat: a white tooth with a cross cut out, on brand red. */
export function LogoMark({ size = 32 }: { size?: number }) {
  return (
    <svg
      className="logo__mark"
      viewBox="-20 -18 140 140"
      width={size}
      height={size}
      aria-hidden="true"
    >
      <rect x="-20" y="-18" width="140" height="140" rx="31.7" fill="var(--brand-red)" />
      <path d={TOOTH} fill="#fff" fillRule="evenodd" />
    </svg>
  );
}

/** The horizontal lockup: the mark, then "Dent" in ink and "log" in red. `size` is the mark's. */
export function Logo({ size = 32 }: { size?: number }) {
  return (
    <span className="logo" style={{ '--logo-size': `${size}px` } as CSSProperties}>
      <LogoMark size={size} />
      {/* No space between the parts: screen readers read one word, "Dentlog". */}
      <span className="logo__word">
        Dent<span className="logo__log">log</span>
      </span>
    </span>
  );
}
